import React, { useState, useEffect } from 'react';
import { sortBy, isNil } from 'lodash';
import { BottomNavigation, BottomNavigationAction, Icon } from "@mui/material";
import { withStyles } from '@mui/styles';
import { withRouter } from 'react-router';
import PetsIcon from '@mui/icons-material/Pets';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ConfirmedShiftsDialog from '../../subcomponents/ConfirmedShiftsDialog';
import { orange } from '../../../css/style';

const styles = theme => ({
  root: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    overflowX: 'hidden',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  navigationAction: {
    fontFamily: 'Asap',
    fontSize: 10,
    fontWeight: 400,
    minWidth: 78,
    position: 'relative',
    '& .MuiBottomNavigationAction-label': {
      fontFamily: 'Asap',
      fontSize: 10,
      fontWeight: 400,
    },
    '& .Mui-selected': {
      color: 'black',
      fontFamily: 'Asap',
      fontSize: 10,
      fontWeight: 400,
    }
  },
  chatBubble: {
    position: 'absolute',
    top: 0,
    right: 23,
    width: 14,
    color: orange,

    [theme.breakpoints.up('sm')]: {
      right: '40%',
    },
    [theme.breakpoints.up('du')]: {
      right: '35%',
    },
  }
});

const BottomNav = (props) => {
  const { resources, user } = props;

  const setNavValue = () => {
    let val = 0;
    if (props.match.path.includes('matches')) {
      val = 0;
    }  else if (props.match.path.includes('search')) {
      val= 1;
    }
    else if (props.match.path.includes('messages')) {
      val =  3;
    } else if (props.match.path.includes('profile')) {
      val = 4;
    }
    return val;
  };

  const [value, setValue] = useState(() => {
    return setNavValue();
  });

  const [openConfirmedShiftsDialog, setOpenConfirmedShiftsDialog] = useState(false);
  const [confirmedShiftsData, setConfirmedShiftsData] = useState(null);
  const [connectedCount, setConnectedCount] = useState(0);
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);
  

  useEffect(() => {
    getMatchStatsData();
  }, []);

  useEffect(() => {
    setValue(setNavValue());
  });

  useEffect(() => {
    const matchesStats = resources && resources['matches/stats'];
    if (matchesStats) {
      setConnectedCount(Number(matchesStats.connected_count));
    }

    const unreadMsgCounts = resources && resources['messages/count-unread-msg-by-match'];
    if (unreadMsgCounts) {
      const unreadCount = Object.keys(unreadMsgCounts).length;
      setTotalUnreadCount(unreadCount);
    }
  }, [resources]);

  useEffect(() => {
    getConfirmedShiftsData();
  }, [connectedCount]);

  const getConfirmedShiftsData = () => {
    const { actions, user } = props;
    if (user && connectedCount > 0 && !confirmedShiftsData) {
      const url = user.intervalDate ? 'reports/worker-confirmation?intervalDate=true' : 'reports/worker-confirmation';
      actions.getAllResources(user.token, url).then((reps) => {
        let data = reps?.response;
        if (data) {
          data = sortBy(data, 'date').reverse();
          data = data.map((row, index) => ({
            ...row,
            id: index,
          }))
        }
        setConfirmedShiftsData(data);
      });
    }
  }

  const getMatchStatsData = () => {
    const { actions, user, resources } = props;

    if (user && !connectedCount) {
      const matchesStats = resources && resources['matches/stats'];
      if (matchesStats) {
        setConnectedCount(Number(matchesStats.connected_count));
      } else {
        actions.getAllResources(user.token, 'matches/stats').then((res) => {
          setConnectedCount(Number(res?.response?.connected_count));
        });
      }
    }
  }
  const isSignUpStudentUser = user && localStorage.getItem(`student_user_${user?.id}`) === 'true';

  return !user ? null : (
    <>
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        switch (newValue) {
          case 0:
            user.isStudent || isSignUpStudentUser ? props.history.push('/externhome') : props.history.push('/');
            break;
          case 1:
            props.history.push('/search');
            break;
          case 2:
            setOpenConfirmedShiftsDialog(true);
            break;
          case 3:
            props.history.push('/messages');
            break;
          case 4:
            props.history.push('/profile');
            break;
          default:
            props.history.push('/')
            break;
        }
        setValue(newValue);
      }}
      showLabels
      className={props.classes.root}
    >
      <BottomNavigationAction className={props.classes.navigationAction} label="Home" icon={<PetsIcon />} />
      {(!user.isStudent && !isSignUpStudentUser) &&
      <BottomNavigationAction className={props.classes.navigationAction} label="Searches" icon={<SearchIcon fill={value === 1 ? '#4bbdad' : '#8896AA'} />} />}
      <BottomNavigationAction className={props.classes.navigationAction} label="Comfirmed" icon={<ThumbUpIcon />} />
      { (connectedCount > 0 || totalUnreadCount > 0 ) && (
        <BottomNavigationAction className={props.classes.navigationAction} label="Messages"
          icon={
            <>
              <ChatBubbleIcon />
              {totalUnreadCount > 0 && <FiberManualRecordIcon className={props.classes.chatBubble} />}
            </>
          }
        />
      )}
      <BottomNavigationAction className={props.classes.navigationAction} label="Profile" icon={<AccountCircleIcon />} />
    </BottomNavigation>

    <ConfirmedShiftsDialog
      open={openConfirmedShiftsDialog}
      handleClose={() => setOpenConfirmedShiftsDialog(false)}
      confirmedShiftsData={confirmedShiftsData}
    />
    </>
  )
}
const SearchIcon = ({ fill = '#8896AA' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1243_119956)">
      <path d="M0.597128 20.3781L5.86404 14.6942C6.79385 15.874 7.9813 16.8519 9.34622 17.5619L4.08367 23.2458C3.88404 23.4619 3.64111 23.6387 3.36883 23.766C3.09654 23.8934 2.80026 23.9688 2.49699 23.9879C2.19373 24.007 1.88944 23.9694 1.6016 23.8774C1.31376 23.7853 1.04804 23.6406 0.819674 23.4515C0.590729 23.2636 0.403329 23.0351 0.268205 22.7789C0.133081 22.5226 0.052887 22.2438 0.0322151 21.9583C0.0115432 21.6728 0.0507992 21.3863 0.147735 21.1152C0.244672 20.844 0.397384 20.5935 0.597128 20.3781ZM5.29822 9.0844C5.28586 8.78269 5.29022 8.48783 5.30986 8.20874C5.38235 7.06067 5.6957 5.93757 6.23176 4.90448C6.76782 3.87138 7.51593 2.94883 8.43277 2.19023C9.34549 1.42829 10.4091 0.844135 11.5623 0.471424C12.7155 0.098713 13.9355 -0.0551923 15.152 0.0185733C16.3696 0.0889234 17.5603 0.385664 18.6557 0.891708C19.7511 1.39775 20.7295 2.1031 21.5346 2.96714C23.1267 4.66443 23.9545 6.87997 23.8422 9.14337L23.8459 9.13995L23.8342 9.29766V9.30177C23.713 11.1425 22.9775 12.9 21.7329 14.3228C20.4883 15.7455 18.7983 16.7607 16.9048 17.2231C16.8815 17.2307 16.8575 17.2341 16.8342 17.2417C16.7141 17.271 16.5931 17.2968 16.4713 17.3191C16.432 17.326 16.3891 17.3377 16.3506 17.3445C16.3346 17.3486 16.3193 17.3486 16.3033 17.3521C16.296 17.3521 16.288 17.3562 16.2764 17.3562L16.2059 17.3671C16.1237 17.3815 16.0422 17.3925 15.96 17.4076C15.9208 17.4145 15.8815 17.4186 15.8429 17.422C15.7571 17.433 15.6749 17.4439 15.5884 17.4515L15.4953 17.4625C15.3819 17.4734 15.2691 17.481 15.1557 17.4885C15.1324 17.4885 15.112 17.4919 15.0895 17.4919L14.8124 17.5029C14.7768 17.5029 14.7382 17.5029 14.7033 17.507H14.3513C14.2655 17.507 14.184 17.5029 14.0975 17.4995C14.0662 17.4995 14.0393 17.4961 14.008 17.4961H13.9848C13.9688 17.4961 13.9491 17.4919 13.9339 17.4919C13.7891 17.481 13.6451 17.47 13.5048 17.4556L13.4066 17.4439C13.0749 17.4035 12.7469 17.3479 12.4269 17.2746C12.4029 17.2677 12.376 17.2636 12.3528 17.2567C12.1885 17.2205 12.0258 17.1787 11.8648 17.1313H11.8604C11.6658 17.0746 11.4732 17.0119 11.2829 16.9434C11.1696 16.9036 11.0576 16.8606 10.9469 16.8145C10.8691 16.7857 10.7942 16.7527 10.7164 16.7185C10.6582 16.6931 10.6 16.6711 10.5411 16.6458H10.5448C10.3213 16.5464 10.1025 16.4382 9.88877 16.3214C9.63495 16.1815 9.61967 15.3937 9.65095 15.2798C10.5455 12.2284 12.856 11.2012 14.9368 10.2741C16.592 9.53354 17.5768 9.12897 18.2713 7.61217C18.4779 7.1596 18.5949 6.75503 18.568 6.57057C18.4509 6.56714 17.8066 6.61446 17.08 6.67343C16.1942 6.74337 15.2139 6.81743 14.4917 6.66246C13.3324 6.4156 13.2349 6.0844 13.0982 5.60234C13.0589 5.47 13.0124 5.30749 12.8408 5.12783C12.6066 4.87412 11.4859 4.70063 10.3026 4.64166C9.89571 4.62051 9.48807 4.6157 9.08076 4.62726C9.08076 4.62726 8.24513 4.74109 7.41022 4.94337C6.79819 5.96197 6.44145 7.0991 6.36731 8.26772C6.34796 8.52742 6.34407 8.78794 6.35567 9.04806C6.36731 9.29834 6.39131 9.5596 6.42986 9.82429C6.43422 9.85377 6.43422 9.88326 6.43422 9.90932C6.45749 11.0099 7.44513 11.6133 8.03422 11.8746C8.59276 10.7116 8.97531 9.81743 9.1004 9.04052C9.22913 8.23412 9.07713 7.53194 8.55422 6.7324C8.47967 6.61919 8.45587 6.4827 8.48806 6.35294C8.52025 6.22319 8.60579 6.11081 8.72586 6.04052C8.84593 5.97023 8.99069 5.94779 9.12831 5.97814C9.26593 6.00848 9.38512 6.08913 9.45967 6.20234C10.1309 7.22954 10.3266 8.1388 10.1542 9.19206C9.99422 10.1815 9.50695 11.2711 8.79204 12.729C8.73647 12.8415 8.63879 12.9308 8.51773 12.9796C8.39668 13.0285 8.26076 13.0335 8.13604 12.9937C7.92513 12.9319 5.41895 12.1399 5.36804 9.9388C5.33313 9.66246 5.30986 9.37926 5.29822 9.0844ZM10.3651 3.64806C11.7906 3.72143 13.2117 4.00874 13.6408 4.46886C13.9724 4.822 14.0553 5.10589 14.1251 5.34452C14.1637 5.4844 14.1913 5.5804 14.7302 5.69423C15.2924 5.81217 16.1906 5.74634 17.0066 5.68326C18.1113 5.59892 19.0866 5.52143 19.4502 5.99663C19.4968 6.0556 19.5324 6.118 19.5593 6.18794C19.7077 6.56714 19.5753 7.2988 19.2466 8.00989C18.3688 9.93126 17.4822 10.3029 15.4248 11.2197C13.5899 12.0371 11.552 12.9422 10.752 15.5335C10.7452 15.5576 10.736 15.5811 10.7244 15.6035C11.0757 15.7804 11.4349 15.9313 11.8059 16.0561L11.8095 16.0526C12.1464 16.1669 12.4909 16.2604 12.8408 16.3324C12.9811 16.3619 13.1259 16.3873 13.2699 16.4099C13.328 16.4167 13.3913 16.4284 13.4495 16.4359C13.5157 16.4428 13.5862 16.4538 13.6568 16.4613C13.7622 16.4723 13.8713 16.4833 13.9804 16.4908C14.0277 16.4942 14.0706 16.4977 14.1171 16.4977C14.2502 16.5059 14.3862 16.5093 14.5193 16.5093H14.6597C14.7848 16.5093 14.9099 16.5059 15.0306 16.4983L15.2182 16.4874C15.3273 16.4798 15.4364 16.4689 15.5455 16.4579C15.624 16.4503 15.7019 16.4394 15.776 16.4284C15.8403 16.4204 15.9044 16.4105 15.968 16.3989L16.0968 16.377C16.3586 16.3324 16.6117 16.2741 16.8575 16.2035C16.8931 16.1925 16.9317 16.1857 16.9666 16.174C17.0297 16.1562 17.0923 16.1368 17.1542 16.1157L17.2953 16.0711C18.9478 15.5261 20.372 14.4967 21.3593 13.1335C21.5935 12.8133 21.7964 12.4753 21.976 12.1214C22.0226 12.033 22.0655 11.9411 22.1091 11.8526L22.1789 11.6908C22.2139 11.6065 22.2495 11.5255 22.2844 11.4405C22.3237 11.3445 22.3586 11.2458 22.3935 11.1498C22.4015 11.1237 22.4131 11.0983 22.4211 11.0723C22.456 10.966 22.4873 10.859 22.5186 10.7486C22.5302 10.7075 22.5419 10.6636 22.5542 10.6231C22.5811 10.5134 22.6088 10.4023 22.632 10.2919C22.6437 10.2405 22.6517 10.1891 22.6633 10.1342C22.6786 10.0492 22.6946 9.96417 22.7062 9.87983C22.879 8.7663 22.7924 7.63065 22.4526 6.55185C22.1127 5.47306 21.5277 4.47701 20.7382 3.63297C20.0259 2.86926 19.1604 2.24588 18.1916 1.79869C17.2228 1.3515 16.1698 1.08933 15.0931 1.02726C13.8171 0.950686 12.5397 1.1564 11.363 1.62799C10.1863 2.09957 9.14272 2.82397 8.31567 3.74337C8.93676 3.64052 9.62331 3.61103 10.3651 3.64737V3.64806Z" fill={fill} />
      <path d="M12.208 6.41625C12.349 6.42507 12.4807 6.48609 12.5743 6.58601C12.6679 6.68593 12.7158 6.81666 12.7076 6.94974C12.6982 7.08275 12.6335 7.20688 12.5276 7.29512C12.4216 7.38335 12.2829 7.42853 12.1418 7.42082C12.0005 7.41255 11.8685 7.35169 11.7748 7.25165C11.6811 7.1516 11.6334 7.02055 11.6421 6.88734C11.6509 6.75412 11.7155 6.62965 11.8216 6.54131C11.9277 6.45296 12.0667 6.40798 12.208 6.41625Z" fill={fill} />
    </g>
    <defs>
      <clipPath id="clip0_1243_119956">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export default withStyles(styles)(withRouter(BottomNav))
